import React from 'react';

import { EOfferFormatKey } from '../../../StoreSettings.types';
import {
  SettingsFieldPath,
  SettingsFieldValue
} from '../AbbreviationsSettingsV2.types';

import { AbbreviationStyleField } from './AbbreviationStyleField';
// import { BaseUnitField } from './BaseUnitField';

interface ITimeFormatPanelProps {
  sectionKey: EOfferFormatKey;
  onCommit: (path: SettingsFieldPath, value: SettingsFieldValue) => void;
}

export const TimeFormatPanel = ({
  sectionKey,
  onCommit
}: ITimeFormatPanelProps): React.ReactElement => (
  <div className="flex flex-col gap-4">
    {/* <BaseUnitField sectionKey={sectionKey} onCommit={onCommit} /> */}
    <AbbreviationStyleField sectionKey={sectionKey} onCommit={onCommit} />
  </div>
);
